import React from 'react'
import {
  DateOfRegistration,
  Firsthand,
  Funding,
  Imported,
  Maintained,
  Mileage
} from '../components'
import FORM_FIELDS_TYPE from '../constants'

const formFields = {
  [FORM_FIELDS_TYPE.VEHICLE_HISTORY]: [
    {
      nodes: [
        props => <DateOfRegistration.FormItem {...props} />,
        props => <Mileage.FormItem {...props} />,
        props => <Firsthand.FormItem {...props} />,
        props => <Imported.FormItem {...props} />,
        props => <Maintained.FormItem {...props} />
      ]
    }
  ],
  [FORM_FIELDS_TYPE.VEHICLE_FINANCING]: [
    {
      nodes: [props => <Funding.FormItem {...props} />]
    }
  ]
}

export default { formFields }
